import { render, staticRenderFns } from "./waterLevelOne.vue?vue&type=template&id=2b389d00&scoped=true&"
import script from "./waterLevelOne.vue?vue&type=script&lang=js&"
export * from "./waterLevelOne.vue?vue&type=script&lang=js&"
import style0 from "./waterLevelOne.vue?vue&type=style&index=0&id=2b389d00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b389d00",
  null
  
)

export default component.exports